import React from "react";
import $ from "jquery";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import ActionTypes from "../../../misc/actionTypes";
import {updateCanvasCount} from "../../../actions/actionFunctions";
import {featureInterface} from "../../../interfaces/featureInterface";
import {SLAT_WALL_POSITIONS} from "../../commonVisualizer/core/constants";

const NavItemPositionModalSlatWall = (props) => {

  const {parent, updateCheckboxes, updateCanvasCount, styles, triangleStyles, isWizard, activeFeature} = props;

  let checkboxDisabled = false;

  const isCurrentFeatureActive = parent.activeFeature && activeFeature
    && (activeFeature.getSplittedFeatureName() === parent.activeFeature.getSplittedFeatureName());

  const buttonClick = (position) => {
    if (checkboxDisabled) {
      return
    }
    if (parent.disabled) {
      parent.disabled = false;
      parent.disabledClick(); // disable also related parts
    }
    if (!isCurrentFeatureActive && activeFeature) {
      activeFeature.handleClick(); // to apply not compatible and so on
    }
    parent.slatWallType = position;
    parent.activeFeatureParts = parent.setActiveFeatureParts();
    updateCheckboxes();
    $(window).trigger(ActionTypes.UPDATE_ALL_ITEMS); // update footer items
    updateCanvasCount();
  };

  const getSlatWallButton = (position) => {
    const checkboxDisabled = false;
    const checked = isCurrentFeatureActive && (parent.slatWallType === position);
    return (
      <button className={"ui-checkbox-wrapper"
        + (position === SLAT_WALL_POSITIONS[1] || position === SLAT_WALL_POSITIONS[3] ? " width--135 text-left" : "")}
              key={position}
              onClick={() => buttonClick(position)}>
        <span className={"ui-checkbox ui-checkbox--small"
          + (checked ? " ui-checkbox--checked" : "") + (checkboxDisabled ? " ui-checkbox--disabled" : "")}/>
          <span className={"ui-checkbox__label ui-checkbox__text" + (checkboxDisabled ? " ui-checkbox__label--disabled" : "")}>
          <FormattedMessage id={"visualizer.laundryRoom.slatWall." + position}/>
        </span>
      </button>
    )
  }

  return (
    <div className={"nav-pos nav-pos--shelf" + (isWizard ? " nav-pos--wizard" : "")}
         style={styles}>
      <span className="nav-pos__triangle" style={triangleStyles}/>
      <div className="nav-pos__content">
        <div className="nav-pos__content-top">
          <h4 className="nav-pos__title bold">Side</h4>
          <div className="nav-pos__buttons">
            {SLAT_WALL_POSITIONS.slice(0, 2).map((position) => getSlatWallButton(position))}
          </div>
        </div>
        <div className="nav-pos__content-bottom">
          <div className="nav-pos__buttons">
            {SLAT_WALL_POSITIONS.slice(2, 4).map((position) => getSlatWallButton(position))}
          </div>
        </div>
      </div>
    </div>
  )
};

NavItemPositionModalSlatWall.propTypes = {
  styles: PropTypes.object,
  triangleStyles: PropTypes.object,
  parent: PropTypes.object.isRequired,
  isWizard: PropTypes.bool,
  checkboxesUpdated: PropTypes.bool.isRequired,
  updateCheckboxes: PropTypes.func.isRequired,
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  return {
    navItemPositionModal: store.navigationState.navItemPositionModal
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
};
export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(NavItemPositionModalSlatWall)
)
